import { IModel } from "maps-angular-components";

export const FUNCAO_REGRA_COMPOSTA = 'Limite inferior/superior composto';

export interface RegraDTO {
  id: string;
  nome?: string;
  inicioVigencia?: string;
  fimVigencia?: string;
  funcao?: string;
  utilizaCarteiraExplodida?: boolean;
  parametros?: any;
  regrasAssociadas?: Regra[];
}
export class Regra implements IModel {

  id: string;
  nome: string;
  inicioVigencia: string;
  fimVigencia: string;
  funcao: string;
  utilizaCarteiraExplodida?: boolean;
  parametros: any = {};
  regrasAssociadas: Regra[];
  constructor(obj?: RegraDTO)
  {
    if(obj){
      this.id = obj.id;
      this.nome = obj.nome;
      this.inicioVigencia = obj.inicioVigencia;
      this.fimVigencia = obj.fimVigencia;
      this.funcao = obj.funcao;
      this.utilizaCarteiraExplodida = obj.utilizaCarteiraExplodida;
      this.parametros = obj.parametros;
      this.regrasAssociadas = obj.regrasAssociadas;
    }

  }

  getId() {
    return this.id;
  }

  getName() {
    return this.nome;
  }

  equals(obj: IModel) {
    return obj.getId() == obj.getId()
  }

  toJSON() {
    return Object.assign(this);
  }
}
